import whenDomReady from 'when-dom-ready';
import { removeAttributes, wrapElements, setElementClassByContainerWith } from '../utils/element';
const setCellLabels = (tables) => {
    const tablesArray = [...tables];
    tablesArray.forEach((table) => {
        const ths = table.querySelectorAll('th');
        const trs = table.querySelectorAll('tr');
        const trsArray = [...trs];
        const thsArray = [...ths];
        trsArray.forEach((tr) => {
            const tds = tr.querySelectorAll('td');
            const tdsArray = [...tds];
            tdsArray.forEach((td, index) => {
                td.setAttribute('data-label', thsArray[index].innerText);
                const children = [...td.childNodes];
                const wrapper = document.createElement('div');
                td.appendChild(wrapper);
                children.forEach((child) => wrapper.appendChild(child));
            });
        });
    });
};
function initialise() {
    const tables = document.querySelectorAll('.fr-view table');
    removeAttributes(tables);
    wrapElements(tables, {
        tagName: 'div',
        attributes: [
            {
                name: 'class',
                value: 'table',
            },
        ],
        callback: (element, classLarge) => setElementClassByContainerWith(element, classLarge || '', ''),
        additional: {
            classLarge: 'table--large',
        },
    });
    setCellLabels(tables);
}
whenDomReady().then(initialise);
